var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          staticClass: "upload-demo",
          attrs: {
            action: _vm.uploadImgUrl,
            headers: _vm.headers,
            "on-success": _vm.handleUploadSuccess,
            "before-upload": _vm.handleBeforeUpload,
            "on-remove": _vm.handleRemove,
            "on-error": _vm.handleUploadError,
            multiple: "",
            limit: _vm.limit,
            "on-exceed": _vm.handleExceed,
            "file-list": _vm.fileList,
            accept: _vm.accept,
            data: { code: _vm.code },
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex-center" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "medium",
                    type: "text",
                    icon: "el-icon-paperclip",
                  },
                },
                [_vm._v(_vm._s(_vm.btnText))]
              ),
              !_vm.desc
                ? _c("span", { staticClass: "font-12 color-666" }, [
                    _vm._v(
                      "\n        （单个附件不超过" +
                        _vm._s(_vm.fileSize) +
                        "M，最多可上传" +
                        _vm._s(_vm.limit) +
                        "个）\n      "
                    ),
                  ])
                : _c(
                    "span",
                    {
                      staticClass:
                        "font-12 color-666 margin-left-15 color-redFont",
                    },
                    [_vm._v(_vm._s(_vm.desc))]
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }